var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-box"},[_c('el-image',{attrs:{"src":require('@images/icon/line_left.png')}}),(_vm.$slots.default)?_c('span',{staticClass:"app-text"},[_vm._t("default")],2):_vm._e(),_c('el-image',{attrs:{"src":require('@images/icon/line_right.png')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }